import React, { useState } from 'react';
import css from './educationalPageComponent.module.css';
import Wave from '../Wave/Wave';
import consultIcon from '../../assets/consult.png';
// import CalltheshotImage from '../../assets/CalltheshotImageNew.png';
// import CalltheShotImageMob from '../../assets/CalltheShotImageMob.png';
import { ReactComponent as LineSmallSvg } from '../../assets/crissCrossSmall.svg';
import { ReactComponent as LineSmallSvgNew } from '../../assets/crissCrossSmallNew.svg';
import { ReactComponent as LineSmallSvgNew2 } from '../../assets/crissCrossSmallNew2.svg';
import { ReactComponent as LineSvg } from '../../assets/crissCrossLine.svg';
import NamedLink from '../NamedLink/NamedLink';
// import individualProvBannerImgMob from '../../assets/individualProvBannerImgMob.png';
import SwitchUserModal from '../SwitchUserModal/SwitchUserModal';
import BusinessFormContainer from '../BusinessFormContainer/BusinessFormContainer';
import StarImg from '../../assets/star.png';
// import GrowWhenReady from '../../assets/GrowWhenReady.png';
// import GrowWhenReadyMob from '../../assets/GrowWhenReadyMob.png';
import classNames from 'classnames';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';
// import FoodbannerImg from '../../assets/FoodBannerImg.png';
// import ratinFoodImg from '../../assets/RatinFoodImg.png';
// import ratinRoundFoodImg from '../../assets/reviewRoundImg.png';
// import ReviewRoundImg from '../../assets/reviewLastImg.png';
// import dishOutImage from '../../assets/dishOutImg.png';
// import NainaBgImg from '../../assets/NInaBgImg.png';
// import CookCreateImg from '../../assets/cookCreateImg.png';

const s3Url = `${process.env.REACT_APP_CLOUDFRONT_URL}/individual-provider`;
const s3DefaultUrl = process.env.REACT_APP_CLOUDFRONT_URL;
const startedButton = ({ isAuthenticated, isProvider, setModalOpen, forStart }) => {
  if (!isAuthenticated) {
    return !forStart ? (
      <NamedLink name="SignupProviderPage" className={css.getStartedLink}>
        Get started for FREE
      </NamedLink>
    ) : (
      <NamedLink name="SignupProviderPage" className={css.startBtn}>
        Start Today
      </NamedLink>
    );
  } else if (isAuthenticated && !isProvider) {
    return !forStart ? (
      <div className={css.getStartedLink} onClick={() => setModalOpen(true)}>
        Get started for FREE
      </div>
    ) : (
      <div className={css.getStartedLink} onClick={() => setModalOpen(true)}>
        Start Today
      </div>
    );
  } else {
    return !forStart ? (
      <NamedLink name="CreateListingPage" className={css.getStartedLink}>
        Get started for FREE
      </NamedLink>
    ) : (
      <NamedLink name="CreateListingPage" className={css.getStartedLink}>
        Start Today
      </NamedLink>
    );
  }
};
const liContent = [
  <>
    <span> Revenue Calculator</span> predict your outcomes and set prices with confidence before you
    publish.
  </>,
  <>
    <span>Trial Spaces</span> to welcome newcomers and encourage first-time bookings
  </>,
  <>
    <span>Sibling or Bring-a-Friend Discounts </span> encourage larger bookings and fill more spots
  </>,
  <>
    <span>Early Bird Discount </span>rewards quick sign-ups and enjoy early cash flow
  </>,
  <>
    <span>Late Joiner Sales</span> and fill remaining spots even after classes begin to maximise
    income.
  </>,
  <>
    <span>Early Drop-off and Late Pick-up </span>support busy parents while earning easy extra
    income
  </>,
  <>
    <span>Deposits and Cash Balance </span>always know who owes what, with payments made simple
  </>,
  //   <>
  //     <span>Visible reviews—attracts new customers</span>
  //   </>,
  //   <>
  //     <span>Website integration—seamlessly add our tools to boost your website</span>
  //   </>,
];

const essentialFeatures = [
  {
    title: 'Seamless Parent Experience',
    desc:
      'Give families a simple way to book your activities. With mobile-friendly booking, saved profiles for faster checkout, and easy updates, parents will love how effortless it is to join your activities.',
  },
  {
    title: 'Post it. Share it. Fill it.',
    desc:
      'Each listing is automatically styled and ready to share straight to Facebook, WhatsApp, and more.— no Canva, no extra effort. Just publish, share, and watch the bookings roll in.',
  },
  {
    title: 'Flexible Scheduling',
    desc:
      'Create and update your schedules in minutes. Whether you’re offering term classes, one-off workshops, or seasonal camps. Activity Time makes it easy to be organised and full.',
  },
  {
    title: 'Simple Pricing and Payments',
    desc:
      'Set your prices your way. Offer single sessions, full-term packages, trial spaces or special discounts. Plus, streamline your cashflow and automate payments with flexible fee options.',
  },
  {
    title: 'Built-in Reporting Essentials',
    desc:
      'Access clear, real-time booking data whenever you need it. Track enrolments, download attendee lists, and spot trends — helping you make smart decisions to grow your business',
  },
  {
    title: 'Connection Made Simple',
    desc:
      'Build loyalty, fill classes, and keep families in the loop — all from one place. From auto-generated sign-in sheets to instant email blasts, you’ll save time and stay top-of-mind.',
  },
];
const CallTheShotsSection = () => (
  <div className={css.CallTheShotsSectionWrapper}>
    <div className={css.workStyleForCall}>
      <div className={css.imagediv}>
        {/* <img src={CalltheshotImage} alt="CalltheshotImage" /> */}
        <img src={`${s3DefaultUrl}/CalltheshotImageNew.png`} alt="CalltheshotImage" />
        {/* <img src={`${s3Url}/GrowWhenReady.png`} alt="CalltheshotImage" /> */}
      </div>
      <div className={css.infoDiv}>
        <p className={css.infoHeading}>Call the shots for your business - with modern software</p>
        <p className={css.infoDesc}>
          Easily build custom listings, offer flexible payment types, automatically collect
          important information, communicate with customers and fill your classes, camps and
          workshops.
        </p>
      </div>
    </div>
  </div>
);

const EducationalPageComponent = props => {
  const { isAuthenticated, isProvider } = props;
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <div className={css.wrapperDiv}>
      {' '}
      <section className={` ${css.HeadWrapper}`}>
        <div className={css.showMob}>
          <p className={`${css.firstHeaderTop} ${css.showForMob}`}>
            Inspire curiosity,
            <br />
            <span className={css.tiltedHeighlight}>
              {' '}
              <span className={css.innerTiltText}>confidence</span>
            </span>{' '}
            <span>and growth </span> — we’ll handle the{' '}
            <span className={css.headerStyle}>
              <LineSmallSvgNew className={`${css.lineSvg}`} />
              admin.
            </span>
          </p>
        </div>
        <div className={css.perkCrd}>
          <div className={css.perkDiv1}>
            <p className={`${css.firstHeaderTop} ${css.showForMob}`}>
              Inspire curiosity,
              <br />
              <span className={css.tiltedHeighlight}>
                {' '}
                <span className={css.innerTiltText}>confidence</span>
              </span>{' '}
              <span>and growth </span> — we’ll handle the{' '}
              <span className={css.headerStyle}>
                <LineSmallSvgNew className={`${css.lineSvg}`} />
                admin.
              </span>
            </p>
            <p className={css.subheader}>Education Activity Providers</p>
            <p className={css.inspireP}>
              Whether you teach maths or language grinds, run creative writing clubs, debating
              societies, chess workshops, coding classes, or study skills courses — if you’re
              helping children or teens strengthen their minds and discover new ways to learn, we’re
              here to take care of the admin behind the scenes. From registrations and payments to
              attendance lists, parent reminders and marketing, Activity Time keeps everything
              organised so you can stay focused on what matters — helping every learner reach their
              potential.
            </p>
            {/* <NamedLink name={'CreateListingPage'} className={css.getStartedLink}>
                  Get started for FREE
                </NamedLink> */}
            {startedButton({
              isAuthenticated,
              isProvider,
              setModalOpen,
              forStart: false
            })}
          </div>
          <div className={css.perkDiv2}>
            <div className={css.plogodv}>
              {/* <img src={`${s3Url}/IndividualProvBanner.png`} className={css.mainBannerImg} /> */}
              <img src={`${s3DefaultUrl}/Stempage1.png`} className={css.mainBannerImg} />
              {/* <img src={individualProvBannerImgMob} className={css.mainImgMob} /> */}
              <img src={`${s3DefaultUrl}/Stempage1.png`} className={css.mainImgMob} />
            </div>
          </div>
        </div>
        {/* </div> */}
      </section>
      <section className={css.greySection}>
        <Wave className={css.wave} colName={`#f2f1ef`} />
        <div className={`${css.secondContainerWarpper} ${css.removeMarginBottom}`}>
          <p className={`${css.firstHeading} ${css.BlackText}`}>
            Your admin assistant for education activities — turning timetables into time saved.
          </p>
          <p className={`${css.gridCardHead} ${css.color}`}>
            Education activity management software that keeps your classes organised — and your focus where it belongs: on your students.{' '}
          </p>
          <div className={`${css.perkCrd} ${css.flex_direction}`}>
            <div className={css.perkDiv1}>
              <img
                className={css.mainImg}
                src={`${s3DefaultUrl}/stem_STEM brochure_41.png`}
                alt=""
              />
              <div className={css.revCrd}>
                <img
                  src={`${s3DefaultUrl}/stem_coach.png`}
                  alt="Activity Time Photo"
                  className={css.stemClub}
                />
                <p className={css.RevCardname}>
                  <span>Cian</span>,&nbsp;STEM Workshops & Camps
                </p>
                <div className={css.starDiv}>
                  <img src={StarImg} alt="star" />
                </div>
                <p>
                  "I used to manage everything through Google Forms and spreadsheets. It took hours
                  to keep track of sign-ups and payments. With Activity Time everything’s automated,
                  parents love it and I finally have time to plan new builds and experiments."
                </p>
              </div>

              <p className={css.belowImgText}>
                Let’s make exploring STEM
                <span className={css.tiltedHeighlight}>
                  <span className={css.innerTiltText}>easier</span>
                </span>{' '}
                <br />
                for you{' '}
              </p>

              {/* <img className={`${css.mainImg} ${css.pad}`} src={`${s3Url}/EasierText.png`} alt="" /> */}
            </div>
            <div className={`${css.perkDiv2} ${css.removePad}`}>
              <BusinessFormContainer
                isIndividualProvider={true}
                mainClassName={css.bsnfrmOverride}
                tncCls={css.tncCls}
                setModalOpen={setModalOpen}
                isAuthenticated={isAuthenticated}
              />
            </div>
          </div>
        </div>
      </section>
      <section className={css.whiteSection}>
        <Wave className={css.wave} colName={`#fff`} />

        <div className={`${css.secondContainerWarpper} ${css.createSectionWrapper}`}>
          <p className={css.firstHeadingTopHead}>
            {/* Coach. Motivate.
            <br /> We'll handle the rest. */}
            Innovate, build,
            <br /> inspire. We’ll handle <br /> the rest.
          </p>
          <div className={css.perkCrdFormotivate}>
            <div className={css.perkDiv1}>
              <p className={css.firstHeadingTop}>
                {/* Coach. Motivate.
                <br /> We'll handle the rest. */}
                Innovate, build,
                <br /> inspire. We’ll handle <br /> the rest.
              </p>
              <p className={classNames(css.inspireP, css.overr)}>Easy online bookings.</p>
              <p>
                No more WhatsApps back n’ forth, manual spreadsheets, sending banking links and
                missed earnings. Activity Time makes it simple for customers to book their spot in
                your next camp, class, or workshop — whether it’s a one-off workshop, a term of
                training, or seasonal camps.
              </p>
              <p className={css.inspirePnew}>You can stop the late night admin now.</p>
            </div>
            <div className={css.perkDiv2}>
              <div className={css.plogodv}>
                {/* <img src={`${s3Url}/CreateInspire.png`} className={css.mainImg} /> */}
                <img src={`${s3DefaultUrl}/stem_STEM brochure_21.png`} className={css.mainImg} />
              </div>
              {/* <button type="button">Start Today</button> */}
            </div>
          </div>
        </div>
        <div className={`${css.whiteSection} ${css.cust}`}>
          <div className={css.backgroundGrad}></div>
          <div className={`${css.secondContainerWarpper} ${css.pos}`}>
            <p className={`${css.firstHeading} ${css.businessHead}`}>
              We know the real breakthroughs happen when experimenting — not in the paperwork.
            </p>
            <div className={css.perkCrdBusiness}>
              <div className={`${css.perkDiv1} ${css.weKnowSec}`}>
                <p className={`${css.firstHeading} ${css.businessHead}`}>
                  We know the real breakthroughs happen when experimenting — not in the paperwork.
                </p>
                <div className={css.grad_background}>
                  <p className={css.whiteTextForgrad}>
                    We know magic happens in the sessions, not in spreadsheets!
                  </p>
                  <p className={`${css.whiteText} `}>
                    <span className={css.allyourdomain}>All your admin in one place:</span>
                    <ul>
                      <li className={css.middlevioletList}>
                        Auto-filled attendee and sign-in sheets (with names, ages, medical, contact
                        and emergency details, etc)
                      </li>
                      <li className={css.middlevioletList}>
                        Automated notifications for new bookings, reminders and reviews
                      </li>
                      <li className={css.middlevioletList}>
                        Auto-filled group emails or individual buyer messaging to stay connected
                      </li>
                    </ul>
                  </p>
                </div>
                {/* <button type="button">Start Today</button> */}
                {/* <div className={css.btnWrapper}>
                  {startedButton({ isAuthenticated, isProvider, setModalOpen, forStart: true })}
                </div> */}
              </div>
              <div className={`${css.perkDiv2} ${css.pos}`}>
                {/* <img src={`${s3Url}/BusinessPicture.png`} className={css.mainImg} /> */}
                <img src={`${s3DefaultUrl}/stem_Group_936.png`} className={css.mainImg} />
                {/* <div className={css.businessSubtext}>
                  <p>Let’s take the admin off your shoulders.</p>
                  <div className={css.lineDivForHero}>
                    <LineSvg className={css.lineSvg} />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div
          className={`${css.secondContainerWarpper} ${css.createSectionWrapper} ${css.changeMargin}`}
        >
          <p className={css.firstHeading}>Start Free, Grow When You’re Ready</p>
          <div className={classNames(css.perkCrd, { [css.revPrkcrd]: false })}>
            <div className={css.perkDiv1}>
              {/* <p>{firstHeading}</p> */}
              <p>
                Flexible pricing and add-ons
                {/* {mainHeading} */}
              </p>
              <p>
                We’ve built in smart features that make listing creation simple (even if you’re not
                tech-savvy) and give families the flexibility they expect — while boosting your
                bookings. With Activity Time you can offer:
              </p>

              <ul>
                {liContent.map((c, index) => {
                  const match = typeof c === 'string' ? c?.match(/^(.*?)(\s*\(.*\))$/) : null; // separate text and bracket part
                  return (
                    <li key={index} className={!false ? css.liCOntent : ''}>
                      {match ? (
                        <>
                          <IoCheckmarkCircleOutline />
                          <div>
                            {match[1]}
                            <span className={css.bracketClass}>{match[2]}</span>{' '}
                          </div>
                        </>
                      ) : (
                        <>
                          <IoCheckmarkCircleOutline />
                          <div>{c}</div>
                        </>
                      )}
                    </li>
                  );
                })}
              </ul>
              {/* {idx > 0 && <button type="button">Start Today</button>} */}
            </div>
            <div className={css.perkDiv2}>
              <div className={css.plogodv}>
                <img src={`${s3DefaultUrl}/stem_Group 2212.png`} className={css.mainImgGrow} />
                <img src={`${s3DefaultUrl}/stem_Group 2212.png`} className={css.mainImgGrowMob} />

                {/* <img src={secondImg} className={css.secImg} /> */}
              </div>
            </div>
          </div>
        </div>
        <div className={css.CalltheShotImageMobDiv}>
          <img src={`${s3DefaultUrl}/CalltheShotImageMob.png`} alt="CalltheShotImageMob" />
        </div>
        <CallTheShotsSection />
        <div className={css.whiteSection}>
          <div
            className={classNames(
              css.secondContainerWarpper,
              css.createSectionWrapper,
              css.override
            )}
          >
            <p className={css.firstHeading}>Essential features to love</p>
            <div className={css.gridContainer}>
              {essentialFeatures.map(info => (
                <div>
                  <p className={css.gridCardHead}>{info.title}</p>
                  <p className={css.gridCardDesc}>{info.desc}</p>
                </div>
              ))}
            </div>
            <div className={css.gridContainerMob}>
              {essentialFeatures.map(info => (
                <div>
                  <ul>
                    <li className={css.gridCardHead}>{info.title}</li>
                  </ul>
                  <p className={css.gridCardDesc}>{info.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={`${css.whiteSection} ${css.pos}`}>
          <div className={css.backgroundGrad2} />
          <div className={`${css.perkCrd} ${css.pos} ${css.workStyle}`}>
            {/* <div className={css.perkDiv2}> */}
            <img className={css.workImg} src={`${s3Url}/CompanyLogoCurve.png`} alt="" />
            <img className={css.workImgMob} src={`${s3Url}/CompanyLogoCurveMob.png`} alt="" />
            {/* </div> */}
            <div className={css.perkDiv1}>
              <div className={css.workTextContainer}>
                <p className={css.whiteText}>We work well with others</p>
                <p className={css.whiteText}>
                  Activity Time seamlessly integrates with your business - from website embeds to
                  multiple marketing integrations.{' '}
                </p>
                {/* <button type="button">Start Today</button> */}

                {startedButton({ isAuthenticated, isProvider, setModalOpen, forStart: true })}
              </div>
            </div>
          </div>
        </div>
        <div className={`${css.secondContainerWarpper} ${css.createSectionWrapper}`}>
          <div className={css.revCrd}>
            <img src={`${s3DefaultUrl}/stem_5_broch.png`} alt="Activity Time Photo" />
            <p>– Rachel, After-School Science Club</p>
            <div className={css.starDiv}>
              <img src={StarImg} alt="star" />
            </div>
            <p>
              “I run after-school STEM clubs in three venues. Activity Time keeps everything synced
              — bookings, payments, parent communications and marketing. I just show up and teach my
              classes - no more late night admin.”
            </p>
          </div>
        </div>
      </section>
      <section className={css.greySection}>
        <Wave className={css.wave} colName={`#f2f1ef`} />
        <div className={`${css.secondContainerWarpper} ${css.createSectionWrapper}`}>
          <div className={css.providerWrapper}>
            <div className={css.providerBoldTextWrapper}>
              <p className={css.boldProviderText}>
                Less admin,
                <br /> more action!
                <br /> Focus on what
                <br /> you <i>love</i> doing.
              </p>
              <div className={css.lineDiv}>
                <LineSmallSvg className={`${css.lineSvg}`} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={`${css.whiteSection} ${css.lastSec}`}>
        <Wave className={css.wave} colName={`#fff`} />
        <div className={`${css.secondContainerWarpper} ${css.createSectionWrapper}`}>
          <div className={css.providerWrapper}>
            <div className={css.consultContainer}>
              <div className={css.btndv}>
                <h3>
                  <span>Got Questions?</span> We’d love to answer them...
                </h3>
                <NamedLink name="ContactUsPage">Contact Us</NamedLink>
              </div>
              <h3>
                Want to skip <br /> the forms?
              </h3>
              <img src={consultIcon} alt="" />
              <span className={css.projectOwner}>Audrey Vance</span>
              <span>Activity Time Founder</span>
              <button
                type="button"
                onClick={() => {
                  if (typeof window !== 'undefined') {
                    window.location.href = 'mailto:audrey@activity-time.com';
                  }
                }}
                className={css.button}
              >
                Schedule a Consultation
              </button>
            </div>
          </div>
        </div>
      </section>
      <SwitchUserModal modalOpen={modalOpen} isProvider={isProvider} setModalOpen={setModalOpen} />
    </div>
  );
};

export default EducationalPageComponent;
